import 'css-chunksrc/client/scenes/projectLogs/log/styles.scss';export default {
  "log": "_log_l6pzn_1",
  "content": "_content_l6pzn_9",
  "title": "_title_l6pzn_17",
  "redirection": "_redirection_l6pzn_21",
  "avatar": "_avatar_l6pzn_34",
  "submissionDate": "_submissionDate_l6pzn_41"
};